import { Outlet } from "react-router";

export default function GfsOffersRoute() {
  return <Outlet />;
}
